module.exports = __webpack_public_path__ + "static/img/popup_bg.c2757694.jpg";